import { GeneralAction } from '@models/models';

export interface SubscriptionCategory {
	default: Array<SubscriptionPlan>;
	Annual: Array<SubscriptionPlan>;
	Monthly: Array<SubscriptionPlan>;
}

export interface SubscriptionPlan {
	actions: SubscriptionActions;
	offeredPrice: SubscriptionPrice;
	planCategory: string;
	planDescriptionHtml: string;
	planFeatures: string;
	planName: string;
	price: SubscriptionPrice;
	priceComment: string;
	priceExplanation: string;
	tags: Array<string>;
}

export interface SubscriptionPlanResponse {
	data: SubscriptionChoosePlan;
	result: string;
}

export interface SubscriptionChoosePlan {
	category: SubscriptionCategory;
	priceComment: string;
	title: string;
}

export interface SubscriptionActions {
	SELECT_PLAN: GeneralAction;
	CURRENT_PLAN: GeneralAction;
	CHOOSE_PLAN: GeneralAction;
	DOWNGRADE_PLAN: GeneralAction;
	CANCEL_SUBSCRIPTION: GeneralAction;
	UPDATE_BILLING: GeneralAction;
	COMPLETE_PAYMENT: GeneralAction;
	[prop: string]: GeneralAction;
}

export interface SubscriptionPrice {
	amount: number;
	amountWithCurrency: string;
	currencySymbol: string;
	invoiceInterval: PriceInterval;
}

export interface PriceInterval {
	intervalType: string;
	intervalCount: number;
	displayName: string;
}

export interface SubscriptionStatusResponse {
	result: string;
	data: SubscriptionStatus;
}

export interface SubscriptionStatus {
	currentPlan: SubscriptionPlan;
	announcements: Array<Announcement>;
	actions: SubscriptionActions;
	priceComment: string;
	newPlan?: SubscriptionPlan;
	loginActions?: SubscriptionActions;
}

export interface SubscriptionPlan {
	properties: {
		[prop: string]: PlanItemDescription;
	};
	planName: string;
}

export interface PlanItemDescription {
	description: string;
	prompt?: string;
}

export interface Announcement {
	actions: SubscriptionActions;
	description: string;
}

export interface SubscriptionModalState<T> {
	state: boolean;
	payload: T;
}

export interface PlanConfig {
	url: string;
}

export enum CommunicationEvents {
	billingUpdateOpen = 'billingUpdateOpen',
	billingUpdateClose = 'billingUpdateClose',
	planCheckoutOpen = 'planCheckoutOpen',
	planCheckoutClose = 'planCheckoutClose',
	planCheckoutBack = 'planCheckoutBack',
	confirmPaymentOpen = 'confirmPaymentOpen',
	confirmPaymentClose = 'confirmPaymentClose',
	updatePaymentOpen = 'updatePaymentOpen',
	updatePaymentClose = 'updatePaymentClose',
	messageReceived = 'messageReceived'
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/subscription/subscription.model.ts